import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xsr-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.css']
})
export class MasterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
